import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import useAuthNavigation from '../../hooks/useAuthNavigation';
import useUIStore from '../../store/uiStore';
import QuickBookingModal from '../citas/QuickBookingModal';

const Header = () => {
  const { logout, currentUser } = useContext(AuthContext);
  const { navigateToLogin } = useAuthNavigation();
  const { toggleSidebar, isQuickBookingOpen, openQuickBooking, closeQuickBooking } = useUIStore();

  const handleLogout = () => {
    logout();
    navigateToLogin();
  };

  // Get clinic data from currentUser's cuenta
  const clinicName = currentUser?.cuenta?.nombre || 'EstetikFlow';
  const clinicLogo = currentUser?.cuenta?.logo;

  return (
    <header className="bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            {/* Hamburger menu button for mobile */}
            <button
              onClick={toggleSidebar}
              className="lg:hidden p-2 rounded-md text-gray-400 hover:text-primary hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
              style={{ minHeight: '44px', minWidth: '44px' }}
            >
              <span className="sr-only">Abrir menú</span>
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
            
            <div className="flex-shrink-0 flex items-center ml-2 lg:ml-0 gap-2">
              {/* Show clinic logo if available */}
              {clinicLogo ? (
                <img 
                  src={clinicLogo} 
                  alt={`${clinicName} Logo`} 
                  className="h-8 w-8 object-contain rounded"
                />
              ) : (
                <img 
                  src="/favicon.ico" 
                  alt="EstetikFlow Logo" 
                  className="h-8 w-auto"
                />
              )}
              <h1 className="text-base sm:text-lg font-bold text-primary">
                <span className="hidden sm:inline">{clinicName} - Sistema de Gestión</span>
                <span className="sm:hidden">{clinicName}</span>
              </h1>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            {/* CI-001: Botón de Cita Rápida por Llamada */}
            <button
              onClick={openQuickBooking}
              className="inline-flex items-center gap-1.5 px-3 sm:px-4 py-2 bg-[#2A9D8F] text-white text-sm font-medium rounded-lg hover:bg-[#227f74] transition-colors shadow-sm"
              style={{ minHeight: '44px' }}
              title="Nueva cita por llamada telefónica"
            >
              <span className="text-lg leading-none">📞</span>
              <span className="hidden sm:inline">Llamada</span>
            </button>
            
            <button
              onClick={handleLogout}
              className="px-3 py-2 sm:px-4 border-2 border-primary-dark text-sm font-medium rounded-md text-primary-dark bg-transparent hover:bg-primary-dark hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-colors"
              style={{ minHeight: '44px' }}
            >
              <span className="hidden sm:inline">Cerrar Sesión</span>
              <span className="sm:hidden">Salir</span>
            </button>
          </div>
        </div>
      </div>
      
      {/* CI-001: Quick Booking Modal */}
      {isQuickBookingOpen && (
        <QuickBookingModal onClose={closeQuickBooking} />
      )}
    </header>
  );
};

export default Header;
